import { render, staticRenderFns } from "./ContactFormsTable.vue?vue&type=template&id=ef94792a&"
import script from "./ContactFormsTable.vue?vue&type=script&lang=js&"
export * from "./ContactFormsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports